module.exports = __webpack_public_path__ + "static/media/gna-farmers.8e8251f3.jpg";